module.exports = __webpack_public_path__ + "img/avatar5.ec04a3c3.png";